import { render, staticRenderFns } from "./sales-order.vue?vue&type=template&id=27ccda68&"
import script from "./sales-order.vue?vue&type=script&lang=js&"
export * from "./sales-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports